import { useEffect, useState } from "react";

type FileItem = {
  id: number;
  thumbnail_url: string;
  title?: string; // optional, in case you want alt text
};

const Footer = () => {
  const [partnerLogos, setPartnerLogos] = useState<FileItem[]>([]);

  useEffect(() => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const fetchPartnerLogos = async () => {
      try {
        const response = await fetch(`${BASE_URL}/partners?category=donor_partners`);
        const data = await response.json();
        setPartnerLogos(data);
      } catch (error) {
        console.error("Failed to fetch partner logos:", error);
      }
    };

    fetchPartnerLogos();
  }, []);

  return (
    <div className="w-full flex flex-wrap justify-center gap-0 p-2 bg-white dark:bg-dark border-b-1 shadow border-t-[#E5E7EB] dark:border-t-[#374151]">
      {partnerLogos.map((file) => (
        <img
          key={file.id}
          src={file.thumbnail_url}
          alt={file.title || "Partner logo"}
          className="h-16 object-contain"
        />
      ))}
    </div>
  );
};

export default Footer;